// 课程列表
const combinationList = () => import('@/pages/arkHome/combinationList.vue');
export default [
  {
    path: '/combinationList',
    name: 'combinationList',
    component: combinationList,
    meta: {
      title: '套餐课程列表',
    },
  },

];
